export class Screen {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly path: string,
  ) {}
}

export class RoleEnum {
  static readonly ADMIN_FULL = new Screen(1, 'Admin Full', '/all');
  static readonly FORM = new Screen(2, 'Form', '/form');
  static readonly GESTOR = new Screen(3, 'Gestor', '/gestor');
  static readonly EVENTOS = new Screen(4, 'Eventos', '/events');
  static readonly DASHBOARD = new Screen(5, 'Dashboard', '/dashboard');
  static readonly INVID = new Screen(6, 'Invid', '/invid');
  static readonly TEMPO_REAL = new Screen(7, 'Tempo Real', '/real-time');
  static readonly TEMPO_REAL_MAP = new Screen(7, 'Tempo Real', '/real-time-map');
  static readonly RELATORIOS = new Screen(8, 'Relatórios', '/reports');
  static readonly OCORRENCIA = new Screen(68, 'Ocorrência', '/occurrence');
  static readonly MOTIVO_OCORRENCIA = new Screen(10, 'Motivo Ocorrência', '/motive-occurrence');
  static readonly EQUIPMENT_VIDEO = new Screen(71, 'Vídeo Equipamento', '/equipment-video');
  static readonly EQUIPMENT_ALERT = new Screen(69, 'Equipment Alert', '/equipment-alert');
  static readonly EQUIPMENT_OPERATION_START = new Screen(70, 'Equipment Operation Start', '/equipment-operation-start');
  static readonly STATUS_EQUIPAMENTOS = new Screen(11, 'Status Equipamentos', '/status-monitoring');
  static readonly STATUS_EQUIPAMENTOS_LIST = new Screen(12, 'Lista Status Equipamentos', '/status-monitoring/list');
  static readonly PBT_CONFIG_ALERT_REPORT = new Screen(13, 'PBT Config Alert Report', '/alert-report');
  static readonly PBT_CONFIG = new Screen(14, 'PBT Config', '/pbt-configuration');
  static readonly PBT_CONFIG_ALERT_CONFIG = new Screen(15, 'PBT Config Alert Configuration', '/alert-configuration');
  static readonly PROCESSAMENTO_TRIAGEM = new Screen(16, 'Processamento Triagem', '/triagem');
  static readonly PROCESSAMENTO_PRE_TRIAGEM = new Screen(17, 'Pré Triagem', '/triagem/preTriagem');
  static readonly PROCESSAMENTO_TRIAGEM_PRIMEIRA = new Screen(18, 'Primeira Triagem', '/triagem/primeiraTriagem');
  static readonly PROCESSAMENTO_TRIAGEM_SEGUNDA = new Screen(19, 'Segunda Triagem', '/triagem/segundaTriagem');
  static readonly PROCESSAMENTO_TRIAGEM_VALIDACAO = new Screen(20, 'Validação Triagem', '/validacao');
  static readonly PROCESSAMENTO_TRIAGEM_HISTORICO = new Screen(21, 'Histórico Triagem', '/historico');
  static readonly PROCESSAMENTO_TRIAGEM_BATCH = new Screen(22, 'Batch Triagem', '/batch');
  static readonly EXPORTACAO = new Screen(23, 'Exportação', '/exportacao');
  static readonly CRUD_ROTAS_EQUIPAMENTOS = new Screen(24, 'CRUD Rotas Equipamentos', '/device-route');
  static readonly TRACKER_VS = new Screen(25, 'Tracker VS', '/tracker-vs');
  static readonly TRACKER_VS_GENERAL = new Screen(26, 'Tracker VS General', '/tracker-vs/general');
  static readonly TRACKER_VS_INTERVAL = new Screen(27, 'Tracker VS Interval', '/tracker-vs/interval');
  static readonly TRACKER_VS_ANALYSIS = new Screen(28, 'Tracker VS Analysis', '/tracker-vs/analysis');
  static readonly TRIAGEM_VALIDACAO_FUNCIONALIDADE_APROVE_ALL = new Screen(29, 'Triagem Validação Aprove All', '/triagem-funcionalidade-aproveAll');
  static readonly SYNC_DIFF = new Screen(30, 'Sincronização', '/sync-diff')

  static values(): Screen[] {
    return [
      RoleEnum.ADMIN_FULL,
      RoleEnum.FORM,
      RoleEnum.GESTOR,
      RoleEnum.EVENTOS,
      RoleEnum.DASHBOARD,
      RoleEnum.INVID,
      RoleEnum.TEMPO_REAL,
      RoleEnum.RELATORIOS,
      RoleEnum.OCORRENCIA,
      RoleEnum.MOTIVO_OCORRENCIA,
      RoleEnum.STATUS_EQUIPAMENTOS,
      RoleEnum.STATUS_EQUIPAMENTOS_LIST,
      RoleEnum.PBT_CONFIG_ALERT_REPORT,
      RoleEnum.PBT_CONFIG,
      RoleEnum.PBT_CONFIG_ALERT_CONFIG,
      RoleEnum.PROCESSAMENTO_TRIAGEM,
      RoleEnum.PROCESSAMENTO_PRE_TRIAGEM,
      RoleEnum.PROCESSAMENTO_TRIAGEM_PRIMEIRA,
      RoleEnum.PROCESSAMENTO_TRIAGEM_SEGUNDA,
      RoleEnum.PROCESSAMENTO_TRIAGEM_VALIDACAO,
      RoleEnum.PROCESSAMENTO_TRIAGEM_HISTORICO,
      RoleEnum.PROCESSAMENTO_TRIAGEM_BATCH,
      RoleEnum.EXPORTACAO,
      RoleEnum.CRUD_ROTAS_EQUIPAMENTOS,
      RoleEnum.TRACKER_VS,
      RoleEnum.TRACKER_VS_GENERAL,
      RoleEnum.TRACKER_VS_INTERVAL,
      RoleEnum.TRACKER_VS_ANALYSIS,
      RoleEnum.TRIAGEM_VALIDACAO_FUNCIONALIDADE_APROVE_ALL,
      RoleEnum.EQUIPMENT_OPERATION_START,
      RoleEnum.SYNC_DIFF,
    ];
  }
}
